import {Icon, Text, View} from '@lookiero/aurora';
import React, {FC} from 'react';
import {useIntl} from 'react-intl';
import {PersonalShopperDialog} from '../_components/PersonalShopperDialog/PersonalShopperDialog';
import {TEXT} from './TrackingDialog.definition';
import {style} from './TrackingDialog.style';

export const TrackingDialog: FC<{trackNumber: string; address: string; username: string}> = ({
  trackNumber,
  address,
  username,
}) => {
  const {formatMessage} = useIntl();

  return (
    <PersonalShopperDialog testID="tracking-dialog" message={formatMessage(TEXT.TRACKING_MESSAGE, {username})}>
      <View style={style.wrapper}>
        <View style={style.row}>
          <Icon name="newsfeed" />
          <View style={style.title}>
            <Text action level={3}>
              {formatMessage(TEXT.TRACKING_NUMBER)}
            </Text>
            <Text level={3}>{trackNumber}</Text>
          </View>
        </View>
        <View style={style.row}>
          <Icon name="truck" />
          <View style={style.title}>
            <Text action level={3}>
              {formatMessage(TEXT.DELIVERY_ADDRESS)}
            </Text>
            <Text level={3}>{address}</Text>
          </View>
        </View>
      </View>
    </PersonalShopperDialog>
  );
};
